module.exports = __webpack_public_path__ + "media/images/temp/icon-7-7f2a1d110fd02af73b04af0e20130770.png";